// Mock data for G.S Contractors website

export const services = [
  {
    id: 1,
    slug: "italian-marble-polishing",
    title: "Marble Cutting & Fixing",
    description: "Searching for marble cutting near me? Our craftsmen deliver precise sizing, laying and joint-free marble fixing across Bangalore — floors, walls, staircases & counters.",
    tags: ["Marble Cutting Near Me", "Marble Fixing Bangalore"],
    image: "https://images.unsplash.com/photo-1758193017781-e3aee6c3e359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxwb2xpc2hlZCUyMG1hcmJsZSUyMGZsb29yfGVufDB8fHx8MTc3NTAyMjc3NXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    slug: "granite-honing",
    title: "Granite Cutting & Fixing",
    description: "Trusted granite fixing in Bangalore for kitchen counters, flooring & commercial halls — heavy-duty cutting, perfect leveling and sealing that lasts for decades.",
    tags: ["Granite Fixing Bangalore", "Granite Cutting Near Me"],
    image: "https://images.unsplash.com/photo-1764021995962-53921e9f2317?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxncmFuaXRlJTIwc3VyZmFjZXxlbnwwfHx8fDE3NzUwMjI3ODB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    slug: "inlay-restoration",
    title: "Italian Marble Laying & Finishing",
    description: "Specialist Italian marble fixing near you — Bottochino, Statuario & Dyna slabs laid with diamond-cut precision and finished to a flawless mirror shine.",
    tags: ["Italian Marble Bangalore", "Import Marble Experts"],
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/qqcwj5b7_design%20gs1.jpeg"
  },
  {
    id: 4,
    slug: "stain-extraction",
    title: "Marble & Granite Polishing",
    description: "The best marble polishing in Bangalore — multi-stage diamond honing and crystallization that restores old, dull floors to a 90+ gloss mirror finish.",
    tags: ["Marble Polishing Bangalore", "Floor Polishing Near Me"],
    image: "https://images.pexels.com/photos/7045766/pexels-photo-7045766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 5,
    slug: "epoxy-grouting",
    title: "Interior Stone & Inlay Work",
    description: "Complete interior stonework near you — puja room inlays, designer wall cladding, tile fixing and epoxy grouting for homes across all Bangalore areas.",
    tags: ["Interior Stone Work", "Tile Fixing Near Me"],
    image: "https://images.unsplash.com/photo-1767460775253-0ab84b798aec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxwb2xpc2hlZCUyMG1hcmJsZSUyMGZsb29yfGVufDB8fHx8MTc3NTAyMjc3NXww&ixlib=rb-4.1.0&q=85"
  }
];

export const galleryImages = [
  {
    id: 1,
    before: "https://images.pexels.com/photos/2083961/pexels-photo-2083961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    after: "https://images.unsplash.com/photo-1758448721149-aa0ce8e1b2c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxwb2xpc2hlZCUyMG1hcmJsZSUyMGZsb29yfGVufDB8fHx8MTc3NTAyMjc3NXww&ixlib=rb-4.1.0&q=85",
    title: "Luxury Marble Floor"
  },
  {
    id: 2,
    before: "https://images.pexels.com/photos/7077998/pexels-photo-7077998.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    after: "https://images.unsplash.com/photo-1588606805498-5c212783a722?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxtYXJibGUlMjBwb2xpc2hpbmd8ZW58MHx8fHwxNzc1MDIyNzY3fDA&ixlib=rb-4.1.0&q=85",
    title: "Granite Kitchen Counter"
  }
];

// Real project images from G.S Contractors
export const projectGallery = [
  // Your Real Project Images - Batch 1
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/qqcwj5b7_design%20gs1.jpeg",
    title: "Sacred OM Symbol Inlay",
    category: "Puja Room",
    description: "Exquisite OM symbol with turquoise inlay in radial sunburst pattern"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/6lvinw8m_design%20gs%20.jpeg",
    title: "Decorative Floral Tiles",
    category: "Flooring",
    description: "Premium marble tiles with intricate floral patterns and golden accents"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/x74k3nxk_design%20gs2.jpeg",
    title: "Ornate Floor Installation",
    category: "Flooring",
    description: "Master craftsmen installing elaborate marble inlay with burgundy and cream patterns"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/tflyb7rg_design%20gs3.jpeg",
    title: "Grand Hall Marble Inlay",
    category: "Commercial",
    description: "Magnificent white marble hall with colorful floral inlay and classical columns"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/m5t04u0c_design%20gs4%20.jpeg",
    title: "Floral Vine Wall Inlay",
    category: "Residential",
    description: "Stunning white marble walls with intricate black and colored stone floral vine patterns"
  },
  // Your Real Project Images - Batch 2
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/772oc6te_design%20gs%206.jpeg",
    title: "Luxury Corridor Design",
    category: "Flooring",
    description: "Polished hallway with elegant dark marble inlay on cream background with decorative chain borders"
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/yo8qjv9v_design%20gs%207.jpeg",
    title: "Ornate Marble Rug Medallion",
    category: "Flooring",
    description: "Exquisite floor medallion with brown and cream floral patterns in decorative frames"
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/h1hxd1hx_design%20gs%208.jpeg",
    title: "Luxury Foyer with Spiral Staircase",
    category: "Residential",
    description: "Elegant white marble foyer featuring circular floral medallion and black decorative borders"
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_gs-marble-polish/artifacts/7gnlilrs_design%20gs%209%20.jpeg",
    title: "Puja Room OM with Lotus",
    category: "Puja Room",
    description: "Sacred puja space with golden OM symbol in lotus pattern, perfect for spiritual sanctum"
  },
  // Stock Images
  {
    id: 10,
    image: "https://images.unsplash.com/photo-1588606805498-5c212783a722?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxtYXJibGUlMjBwb2xpc2hpbmd8ZW58MHx8fHwxNzc1MDIyNzY3fDA&ixlib=rb-4.1.0&q=85",
    title: "Polished Marble Floor",
    category: "Polishing",
    description: "Professional marble polishing with mirror-like finish"
  },
  {
    id: 11,
    image: "https://images.unsplash.com/photo-1758193017781-e3aee6c3e359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxwb2xpc2hlZCUyMG1hcmJsZSUyMGZsb29yfGVufDB8fHx8MTc3NTAyMjc3NXww&ixlib=rb-4.1.0&q=85",
    title: "Luxury Commercial Space",
    category: "Commercial",
    description: "Premium marble installation for commercial projects"
  },
  {
    id: 12,
    image: "https://images.unsplash.com/photo-1767460775253-0ab84b798aec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxwb2xpc2hlZCUyMG1hcmJsZSUyMGZsb29yfGVufDB8fHx8MTc3NTAyMjc3NXww&ixlib=rb-4.1.0&q=85",
    title: "Designer Marble Flooring",
    category: "Flooring",
    description: "Custom pattern marble floor installation"
  },
  {
    id: 13,
    image: "https://images.pexels.com/photos/7045766/pexels-photo-7045766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Heritage Building",
    category: "Residential",
    description: "Marble work for residential properties"
  },
  {
    id: 14,
    image: "https://images.unsplash.com/photo-1758448721149-aa0ce8e1b2c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxwb2xpc2hlZCUyMG1hcmJsZSUyMGZsb29yfGVufDB8fHx8MTc3NTAyMjc3NXww&ixlib=rb-4.1.0&q=85",
    title: "Polished Marble Restoration",
    category: "Polishing",
    description: "Expert marble polishing and restoration services"
  },
  {
    id: 15,
    image: "https://images.pexels.com/photos/2083961/pexels-photo-2083961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Luxury Residential",
    category: "Residential",
    description: "Premium marble fixing for luxury homes"
  },
  {
    id: 16,
    image: "https://images.pexels.com/photos/7077998/pexels-photo-7077998.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Granite Surfaces",
    category: "Flooring",
    description: "Professional granite polishing services"
  },
  {
    id: 17,
    image: "https://images.unsplash.com/photo-1764021995962-53921e9f2317?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxncmFuaXRlJTIwc3VyZmFjZXxlbnwwfHx8fDE3NzUwMjI3ODB8MA&ixlib=rb-4.1.0&q=85",
    title: "Premium Granite Work",
    category: "Commercial",
    description: "High-quality granite installation and polishing"
  }
];

export const galleryCategories = [
  { id: 'all', label: 'All Projects', count: 17 },
  { id: 'puja room', label: 'Puja Room', count: 2 },
  { id: 'flooring', label: 'Flooring', count: 7 },
  { id: 'commercial', label: 'Commercial', count: 2 },
  { id: 'residential', label: 'Residential', count: 4 },
  { id: 'polishing', label: 'Polishing', count: 2 }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "Koramangala, Bangalore",
    rating: 5,
    text: "Excellent service! They transformed my old marble floor into a mirror-like finish. Very professional team and affordable pricing.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Whitefield, Bangalore",
    rating: 5,
    text: "Best marble polishing service in Bangalore! The team was punctual, clean, and the results exceeded my expectations. Highly recommended!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Venkatesh Reddy",
    location: "Indiranagar, Bangalore",
    rating: 5,
    text: "Outstanding work on our Italian marble. They completed the job on time and the finish is absolutely stunning. Worth every rupee!",
    date: "3 weeks ago"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "40-Year Bangalore Legacy",
    description: "Established 1984 — four decades of stone craftsmanship across the city's finest homes."
  },
  {
    id: 2,
    title: "Zero-Dust Wet Honing",
    description: "German wet diamond systems that leave your home clean, not in a dust storm."
  },
  {
    id: 3,
    title: "90+ Gloss Guarantee",
    description: "Measured mirror-reflection gloss levels documented on every finished floor."
  },
  {
    id: 4,
    title: "Transparent Sq.Ft. Pricing",
    description: "Written quotes with no hidden charges and no mid-job surprises."
  },
  {
    id: 5,
    title: "Master-Supervised Execution",
    description: "Every site is led by a senior craftsman — never handed off to apprentices."
  },
  {
    id: 6,
    title: "Free Sample Patch Demo",
    description: "We polish a small patch of your floor free before you commit a single rupee."
  }
];

export const businessInfo = {
  name: "G.S Contractors",
  phone: "+919844101906",
  whatsapp: "919844101906",
  location: "Bangalore, India",
  email: "ansshar3214@gmail.com"
};
